import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const apiurl = "https://api.stockastix.com";

// Async thunk for fetching stock details
export const fetchStockDetails = createAsyncThunk(
  'ticker/fetchStockDetails',
  async (ticker, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${apiurl}/ticker/get-stock-details/`, { ticker });
      return response.data; // Store the entire backend response as is
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.error);
      }
      return rejectWithValue('Failed to fetch stock details.');
    }
  }
);

const tickerSlice = createSlice({
  name: 'ticker',
  initialState: {
    symbol: null,
    stock: null,         // Stores stock information (company name, description, news, etc.)
    historical_data: [],         // Stores historical data (price data)
    financial_statements: {},    // Stores financial statements (income statement, balance sheet)
    loading: false,
    error: null,
  },
  reducers: {
    clearStockDetails: (state) => {
      state.symbol = null;
      state.stock = null;
      state.historical_data = [];
      state.financial_statements = {};
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchStockDetails
      .addCase(fetchStockDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStockDetails.fulfilled, (state, action) => {
        state.loading = false;
        const { symbol, stock, historical_data, financial_statements } = action.payload;
        state.symbol = symbol;
        state.stock = stock;               // Stock info (company name, description, etc.)
        state.historical_data = historical_data;   // Historical price data
        state.financial_statements = financial_statements; // Financial data (income statement, balance sheet)
      })
      .addCase(fetchStockDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStockDetails } = tickerSlice.actions;

export default tickerSlice.reducer;
